import type { TourTheme } from '@carboncopyco/types';
import { DropdownItem, TextBoxEditorTitle } from '@carboncopyco/ui';
import { TourThemeItem } from './TourThemeItem';

export type TourThemeCategoryProps = {
  tourThemes: TourTheme[];
  label: string;
  selectedThemeId: number;
  onThemeSelect: (tourTheme: TourTheme) => void;
  onThemeDelete?: (tourTheme: TourTheme) => void;
  showMoreOptionsThemeDropdown?: (tourTheme: TourTheme) => boolean;
};

export const TourThemeCategory = ({
  label,
  tourThemes,
  selectedThemeId,
  onThemeSelect,
  onThemeDelete,
  showMoreOptionsThemeDropdown = () => false,
}: TourThemeCategoryProps) => {
  return (
    <>
      <div className="mb-2">
        <TextBoxEditorTitle
          label={label}
          uppercase
          fontWeight="font-ds-semibold"
          color="text-ds-natural-400"
        />
      </div>
      {tourThemes.map((theme) => (
        <DropdownItem key={theme.name}>
          <TourThemeItem
            tourTheme={theme}
            isActive={selectedThemeId === theme.id}
            onClick={onThemeSelect}
            showMoreOptionsDropdown={showMoreOptionsThemeDropdown(theme)}
            onDelete={onThemeDelete}
          />
        </DropdownItem>
      ))}
    </>
  );
};
